var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"row-body",style:(_vm.bgc.background),attrs:{"row":""}},[_c('v-flex',{staticStyle:{"height":"'100%'"}},[_c('div',{staticClass:"item-label",style:(_vm.bgc.label)},[_vm._v(_vm._s(_vm.args.label))]),_c('div',{staticClass:"item-value",style:(_vm.bgc.value)},[_vm._v(_vm._s(_vm.args.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }